import { Component, OnInit } from '@angular/core';
import { BookingService } from '../appservices/booking.service';
import { LoaderService } from '../sharedcomponents/index';

@Component({
  selector: 'app-switch-payment-mode',
  templateUrl: './switch-payment-mode.component.html',
  styleUrls: ['./switch-payment-mode.component.scss']
})
export class SwitchPaymentModeComponent implements OnInit {

  currentMode: string | null = null;
  loading = true;
  switching = false;
  successMessage = '';
  errorMessage = '';

  constructor(
    private bookingService: BookingService,
    private loader: LoaderService
  ) {}

  ngOnInit() {
    this.loadCurrentMode();
  }

  async loadCurrentMode() {
    this.loading = true;
    this.errorMessage = '';
    try {
      const res: any = await this.bookingService.getPaymentMode();
      this.currentMode = res.paymentMode;
    } catch (err) {
      this.errorMessage = 'Failed to load current payment mode.';
    } finally {
      this.loading = false;
    }
  }

  get targetMode(): string {
    return this.currentMode === 'prepaid' ? 'pay now' : 'prepaid';
  }

  get modeLabel(): string {
    return this.currentMode === 'prepaid' ? 'Prepaid' : 'Pay Now';
  }

  get targetModeLabel(): string {
    return this.targetMode === 'prepaid' ? 'Prepaid' : 'Pay Now';
  }

  async switchMode() {
    this.switching = true;
    this.successMessage = '';
    this.errorMessage = '';
    this.loader.display(true);
    try {
      const res: any = await this.bookingService.switchPaymentMode(this.targetMode);
      if (res && res.status === 'success') {
        this.currentMode = this.targetMode;
        this.successMessage = `Payment mode switched to "${this.targetModeLabel}" successfully.`;
      } else {
        this.errorMessage = 'Switch failed. Please try again.';
      }
    } catch (err) {
      this.errorMessage = 'An error occurred while switching payment mode.';
    } finally {
      this.switching = false;
      this.loader.display(false);
    }
  }
}
